import React from 'react';
import { Zap, Users, TrendingUp, Award, Clock, Shield } from 'lucide-react';

const WhyChooseSection = () => {
  const reasons = [
    {
      icon: <Zap size={40} />,
      title: 'Future-Ready Technology',
      description: 'Solutions that evolve with your business needs, leveraging the latest advancements in AI, automation, and cloud technologies.'
    },
    {
      icon: <Users size={40} />,
      title: 'Deep Cross-Industry Insights',
      description: 'Proven expertise from industry leaders who understand the unique challenges of hospitality, CRE, and technology sectors.'
    },
    {
      icon: <TrendingUp size={40} />,
      title: 'Personalized Consulting',
      description: 'Tailored implementation support and strategic guidance designed specifically for your organization\'s goals and workflows.'
    },
    {
      icon: <Award size={40} />,
      title: 'Proven Leadership',
      description: 'Founded by successful entrepreneurs and industry veterans with decades of combined experience in innovation and growth.'
    },
    {
      icon: <Clock size={40} />,
      title: 'Rapid Implementation',
      description: 'Fast deployment with minimal disruption, getting your team up and running quickly with comprehensive training and support.'
    },
    {
      icon: <Shield size={40} />,
      title: 'Security & Compliance',
      description: 'Enterprise-grade security with built-in compliance features ensuring your data and operations remain protected.'
    }
  ];

  return (
    <section id="why-choose" style={{
      background: 'var(--bg-primary)',
      padding: '100px 7.6923%',
      position: 'relative'
    }}>
      <div style={{
        maxWidth: '1400px',
        margin: '0 auto'
      }}>
        {/* Section Header */}
        <div style={{ textAlign: 'center', marginBottom: '60px' }}>
          <div style={{
            display: 'inline-block',
            padding: '8px 16px',
            background: 'rgba(0, 255, 209, 0.1)',
            border: '1px solid var(--brand-primary)',
            marginBottom: '20px',
            fontSize: '14px',
            color: 'var(--brand-primary)',
            fontWeight: '500'
          }}>
            WHY CHOOSE VDM
          </div>
          <h2 className="display-large" style={{ marginBottom: '20px' }}>
            Partner with <span style={{ color: 'var(--brand-primary)' }}>Innovation Leaders</span>
          </h2>
          <p className="body-medium" style={{ maxWidth: '800px', margin: '0 auto' }}>
            Experience the VDM difference: where cutting-edge technology meets deep industry expertise to deliver transformative results.
          </p>
        </div>

        {/* Reasons Grid */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(350px, 1fr))',
          gap: '40px'
        }}>
          {reasons.map((reason, index) => (
            <div key={index} style={{
              padding: '40px',
              background: 'rgba(255, 255, 255, 0.03)',
              border: '1px solid var(--border-subtle)',
              transition: 'all 0.4s ease-in-out',
              cursor: 'pointer'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.borderColor = 'var(--brand-primary)';
              e.currentTarget.style.background = 'rgba(0, 255, 209, 0.08)';
              e.currentTarget.style.transform = 'translateY(-8px)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.borderColor = 'var(--border-subtle)';
              e.currentTarget.style.background = 'rgba(255, 255, 255, 0.03)';
              e.currentTarget.style.transform = 'translateY(0)';
            }}
            >
              <div style={{
                color: 'var(--brand-primary)',
                marginBottom: '20px'
              }}>
                {reason.icon}
              </div>
              <h3 className="heading-3" style={{ marginBottom: '12px' }}>
                {reason.title}
              </h3>
              <p className="body-small">
                {reason.description}
              </p>
            </div>
          ))}
        </div>

        {/* Stats Bar */}
        <div style={{
          marginTop: '80px',
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
          gap: '40px',
          padding: '60px',
          background: 'rgba(0, 255, 209, 0.05)',
          border: '1px solid var(--brand-primary)'
        }}>
          <div style={{ textAlign: 'center' }}>
            <div style={{
              fontSize: '48px',
              fontWeight: '600',
              color: 'var(--brand-primary)',
              marginBottom: '12px'
            }}>10+</div>
            <div className="body-small" style={{ color: 'var(--text-muted)' }}>Years Combined Experience</div>
          </div>
          <div style={{ textAlign: 'center' }}>
            <div style={{
              fontSize: '48px',
              fontWeight: '600',
              color: 'var(--brand-primary)',
              marginBottom: '12px'
            }}>7</div>
            <div className="body-small" style={{ color: 'var(--text-muted)' }}>Active Solutions</div>
          </div>
          <div style={{ textAlign: 'center' }}>
            <div style={{
              fontSize: '48px',
              fontWeight: '600',
              color: 'var(--brand-primary)',
              marginBottom: '12px'
            }}>100%</div>
            <div className="body-small" style={{ color: 'var(--text-muted)' }}>Client Satisfaction</div>
          </div>
          <div style={{ textAlign: 'center' }}>
            <div style={{
              fontSize: '48px',
              fontWeight: '600',
              color: 'var(--brand-primary)',
              marginBottom: '12px'
            }}>24/7</div>
            <div className="body-small" style={{ color: 'var(--text-muted)' }}>Dedicated Support</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseSection;